module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_pp1_4.924e3526.png";